import { IS_TESTING } from "@/__main__/constants.mjs";

export default function testId(value) {
  return IS_TESTING ? { "data-testid": value } : null;
}
